export const EMPTY_TICK_LABEL = '';

export const MIN_VALUE_RATIO = 0.7;
export const MAX_VALUE_RATIO = 1.4;

export const MAX_BUBBLE_RATIO = 0.7;
export const LIMIT_BUBBLE_RATIO = 1;
export const DEFAULT_EXTRA_MARGIN = 0;

export const LABELS_OFFSET_RATIO = -0.1;
export const LIMIT_BUBBLE_LABEL_WIDTH = 1.4; // 2(radius) * 0.7;
export const LIMIT_BUBBLE_VALUE_WIDTH = 1; // 2(radius) * 0.5;
export const MAX_BUBBLE_LABEL_SCALE = 1.7;
export const TEXT_HEIGHT_OFFSET_RATIO = 2 / 3;
export const DEFAULT_BUBBLE_LABEL_SCALE = 1;
